<template>
    <div
        class="cal-day"
        :class="{
            'cal-day--empty': !day.day,
            'cal-day--today': day.isToday,
            'cal-day--has-games': day.games.length > 0,
            'cal-day--outside': !day.day,
        }"
    >
        <template v-if="day.day">
            <div class="cal-day__header">
                <span class="cal-day__num">{{ day.day }}</span>
            </div>
            <div class="cal-day__games">
                <CalendarMatchItem
                    v-for="game in day.games"
                    :key="game.id"
                    :game="game"
                    @select="$emit('select-game', $event)"
                />
            </div>
        </template>
    </div>
</template>

<script setup>
import CalendarMatchItem from './CalendarMatchItem.vue';

defineProps({
    day: {
        type: Object,
        required: true,
    },
});

defineEmits(['select-game']);
</script>

<style lang="scss" scoped>
@import '../../../../scss/tokens';

.cal-day {
    min-height: 7.5rem;
    border: 1px solid rgba(15, 23, 42, 0.08);
    background: rgba(255, 255, 255, 0.72);
    display: flex;
    flex-direction: column;
    padding: 0.35rem;
    min-width: 0;

    &--empty {
        background: rgba(232, 238, 245, 0.55);
    }

    &--today {
        background: $color-brand-alpha-soft;
        box-shadow: inset 0 0 0 2px $color-brand;
    }

    &--has-games {
        background: #fff;
    }
}

.cal-day__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.3rem;
    flex-shrink: 0;
}

.cal-day__num {
    font-size: 0.8rem;
    font-weight: 700;
    color: $color-text-primary;
    line-height: 1;
}

.cal-day--today .cal-day__num {
    color: $color-brand;
}

.cal-day__games {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}
</style>
